import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=64458d0b&scoped=true"
import script from "./Pc.vue?vue&type=script&lang=js"
export * from "./Pc.vue?vue&type=script&lang=js"
import style0 from "./Pc.vue?vue&type=style&index=0&id=64458d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64458d0b",
  null
  
)

export default component.exports